import { X, Check, Star } from "lucide-react";

const comparisonData = [
  {
    feature: "Contenido estructurado",
    generic: false,
    noStructure: true,
    dsa: true,
  },
  {
    feature: "Herramientas complementarias",
    generic: false,
    noStructure: false,
    dsa: true,
  },
  {
    feature: "Entorno de comunidad",
    generic: false,
    noStructure: false,
    dsa: true,
  },
  {
    feature: "Ruta práctica organizada",
    generic: false,
    noStructure: true,
    dsa: true,
  },
  {
    feature: "Orientación comercial clara",
    generic: false,
    noStructure: false,
    dsa: true,
  },
  {
    feature: "Proveedor educativo definido",
    generic: false,
    noStructure: false,
    dsa: true,
  },
];

export default function DifferentiatorSection() {
  return (
    <section
      data-testid="differentiator-section"
      className="py-20 md:py-28 bg-white"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-sm uppercase tracking-[0.25em] font-semibold text-[#0F3D56] mb-4 block">
            Por qué esta propuesta
          </span>
          <h2
            className="text-3xl md:text-5xl font-semibold text-[#111827] mb-6"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            No es solo contenido aislado
          </h2>
          <p className="text-base text-gray-600 leading-relaxed">
            Compara lo que recibes en distintos formatos y entiende 
            por qué una ruta estructurada con contexto puede marcar la diferencia.
          </p>
        </div>

        {/* Comparison Table */}
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr>
                <th className="text-left py-4 px-4 text-sm font-medium text-gray-500">
                  Característica
                </th>
                <th className="text-center py-4 px-4">
                  <div className="text-sm font-medium text-gray-400">
                    Contenido suelto
                  </div>
                  <div className="text-xs text-gray-400 mt-1">
                    (YouTube, blogs)
                  </div>
                </th>
                <th className="text-center py-4 px-4">
                  <div className="text-sm font-medium text-gray-400">
                    Información sin estructura
                  </div>
                  <div className="text-xs text-gray-400 mt-1">
                    (Solo videos)
                  </div>
                </th>
                <th className="text-center py-4 px-4 bg-[#0F3D56]/5 rounded-t-lg">
                  <div className="flex items-center justify-center gap-2">
                    <Star size={16} className="text-[#D4C4A8] fill-[#D4C4A8]" />
                    <span className="text-sm font-bold text-[#0F3D56]">Evaluación con DSA</span>
                  </div>
                  <div className="text-xs text-[#0F3D56]/70 mt-1">
                    + Programa MINED
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, index) => (
                <tr
                  key={index}
                  data-testid={`comparison-row-${index}`}
                  className="border-t border-gray-100"
                >
                  <td className="py-4 px-4 text-sm text-gray-700">
                    {row.feature}
                  </td>
                  <td className="py-4 px-4 text-center">
                    {row.generic ? (
                      <Check size={20} className="text-gray-400 mx-auto" />
                    ) : (
                      <X size={20} className="text-gray-300 mx-auto" />
                    )}
                  </td>
                  <td className="py-4 px-4 text-center">
                    {row.noStructure ? (
                      <Check size={20} className="text-gray-400 mx-auto" />
                    ) : (
                      <X size={20} className="text-gray-300 mx-auto" />
                    )}
                  </td>
                  <td className="py-4 px-4 text-center bg-[#0F3D56]/5">
                    <div className="inline-flex items-center justify-center w-8 h-8 bg-[#0F3D56] rounded-full">
                      <Check size={16} className="text-white" />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Bottom Note */}
        <div className="mt-12 text-center">
          <p className="text-sm text-gray-500 max-w-2xl mx-auto">
            La combinación de contenido estructurado, herramientas complementarias, 
            comunidad y orientación comercial clara es lo que diferencia esta propuesta.
          </p>
        </div>
      </div>
    </section>
  );
}
